import DiaryViewTabs from "@/features/diaries/components/DiaryViewTabs";
import { createFileRoute } from "@tanstack/react-router";
import { Outlet } from "@tanstack/react-router";

const FootWatch = () => {
	return (
		<section className="md-width">
			<div className="mx-4 my-6 w-md">
				<DiaryViewTabs />
			</div>
			<Outlet />
		</section>
	);
};

export const Route = createFileRoute("/_app/foot-watch/$diaryId/_view")({
	component: FootWatch,
});
